/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useEffect, useState} from 'react'
import {deletePromo, getAllPromo, searchPromo} from '../api/promo'
import {Link, useParams} from 'react-router-dom'
import {parseDate} from '../../../../utils/dateAndTime'
import {PromoListModel} from '../interface/Promo'
import {toast} from 'react-toastify'
import Pagination from '../../../components/Pagination'
import ModalDelete from '../../../components/Modals/ModalDelete'
import Search from '../../../components/Search'
import moment from 'moment'
import Spinner from '../../../components/Spinner'
import NoData from '../../../components/common/NoData'
// import ModalAddPromo from '../modal/ModalAddPromo'

interface IPageParams {
  page: string
}

const ListPromo: FC = () => {
  const [promoList, setPromoList] = useState<PromoListModel>()
  const [search, setSearch] = useState<string>('')
  const [deleteId, setDeleteId] = useState<string>('')
  const {page} = useParams<IPageParams>()
  const [loading, setLoading] = useState<boolean>(true)

  function getPromo() {
    getAllPromo(page)
      .then((data) => {
        setLoading(false)
        setPromoList(data)
      })
      .catch((err) => {
        setLoading(false)
        toast.error('Error!')
      })
  }
  useEffect(() => {
    getPromo()
  }, [page])

  function handleDelete(event: React.ChangeEvent<any>, id: string) {
    event.preventDefault()
    deletePromo(id).then((data) => {
      toast.success('Success!')
      getPromo()
    })
  }
  function handleSearch(event: React.ChangeEvent<any>) {
    event.preventDefault()
    const {value} = event.target
    setSearch(value)
    if (value === '') {
      getPromo()
      return
    }
    searchPromo(search).then((data) => {
      setPromoList(data)
    })
  }

  return (
    <div className='d-flex flex-column flex-column-fluid' id='kt_content'>
      {/*begin::Post*/}
      <div className='post d-flex flex-column-fluid' id='kt_post'>
        {/*begin::Container*/}
        <div id='kt_content_container' className='container-xxl'>
          {/*begin::Card*/}
          <div className='card'>
            {/*begin::Card promo*/}
            <div className='card-header border-0 pt-6'>
              {/*begin::Card title*/}
              <div className='card-title'>
                {/*begin::Search*/}
                <Search name={search} placeholder='Promo' handleSearch={handleSearch} />
                {/*end::Search*/}
              </div>
              {/*begin::Card title*/}
              {/*begin::Card toolbar*/}
              <div className='card-toolbar'>
                {/*begin::Toolbar*/}
                <div className='d-flex justify-content-end' data-kt-promo-table-toolbar='base'>
                  {/* <ModalAddPromo handleGetPromo={getPromo} /> */}
                  <Link className='btn btn-primary' to='/promo/new'>
                    Add Promocode
                  </Link>
                </div>
                {/*end::Toolbar*/}
                {/*begin::Modal - Delete*/}
                <ModalDelete id={deleteId} handleDelete={handleDelete} />
                {/*end::Modal - delete*/}
              </div>
              {/*end::Card toolbar*/}
            </div>
            {/*end::Card promo*/}
            {/*begin::Card body*/}
            <div className='card-body pt-0'>
              {/*begin::Table*/}
              <div
                id='kt_table_promos_wrapper'
                className='dataTables_wrapper dt-bootstrap4 no-footer'
              >
                <div className='table-responsive'>
                  {loading ? (
                    <Spinner />
                  ) : (
                    <table className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'>
                      {/*begin::Table head*/}
                      <thead>
                        {/*begin::Table row*/}
                        <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
                          <th className='min-w-125px' style={{width: '240.65px'}}>
                            Promo
                          </th>
                          <th
                            className='min-w-125px'
                            tabIndex={0}
                            aria-controls='kt_table_promos'
                            rowSpan={1}
                            colSpan={1}
                            style={{width: '134.65px'}}
                            aria-label='Role: activate to sort column ascending'
                          >
                            End Date
                          </th>
                          <th
                            className='min-w-125px'
                            aria-controls='kt_table_promos'
                            style={{width: '140.417px'}}
                          >
                            Featured
                          </th>
                          <th
                            className='min-w-125px'
                            aria-controls='kt_table_promos'
                            style={{width: '140.417px'}}
                            aria-label='Joined Date: activate to sort column ascending'
                          >
                            Created Date
                          </th>
                          <th
                            className='text-end min-w-100px sorting_disabled'
                            rowSpan={1}
                            colSpan={1}
                            style={{width: '106.433px'}}
                            aria-label='Actions'
                          >
                            Actions
                          </th>
                        </tr>
                        {/*end::Table row*/}
                      </thead>
                      {/*end::Table head*/}
                      {/*begin::Table body*/}
                      {promoList && (
                        <tbody className='text-gray-600 fw-bold'>
                          {promoList.data.length === 0 && <NoData />}
                          {promoList.data.length !== 0 &&
                            promoList.data.map((item) => {
                              return (
                                <tr className='odd' key={item._id}>
                                  {/*begin::Promo=*/}
                                  <td className='d-flex align-items-center'>
                                    {/*begin:: Avatar */}
                                    <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
                                      <Link to={`/promo/view/${item._id}`}>
                                        <div className='symbol-label fs-3 bg-light-primary text-primary'>
                                          {item.image ? (
                                            <img
                                              src={item.image}
                                              alt='promo'
                                              height='50px'
                                              width='50px'
                                            />
                                          ) : (
                                            'N'
                                          )}
                                        </div>
                                      </Link>
                                    </div>
                                    {/*end::Avatar*/}
                                    {/*begin::Promo details*/}
                                    <div className='d-flex flex-column'>
                                      <Link
                                        to={`/promo/view/${item._id}`}
                                        className='text-gray-800 text-hover-primary mb-1'
                                      >
                                        {item.name}
                                      </Link>
                                      <span>{item.tagline}</span>
                                    </div>
                                    {/*begin::Promo details*/}
                                  </td>
                                  {/*end::Promo=*/}
                                  {/*begin::validity */}
                                  <td>{moment(item.end_date).format('DD-MMM-YYYY h:mm:ss A')}</td>
                                  {/*begin::validity */}
                                  {/*begin::featured*/}
                                  <td>
                                    {item.is_featured ? (
                                      <div className='badge badge-light-success fw-bolder'>
                                        Featured
                                      </div>
                                    ) : (
                                      <div className='badge badge-light-danger fw-bolder'>
                                        Not Featured
                                      </div>
                                    )}
                                  </td>
                                  {/*end:: featured*/}
                                  {/*begin::Joined*/}
                                  <td>{parseDate(item.createdAt)}</td>
                                  {/*begin::Joined*/}
                                  {/*begin::Action=*/}
                                  <td className='text-end'>
                                    <Link
                                      to={`/promo/edit/${item._id}`}
                                      className='btn btn-bg-light btn-color-muted btn-active-color-primary btn-sm px-4 me-2'
                                    >
                                      Edit
                                    </Link>
                                    <a
                                      href='#'
                                      className='btn btn-danger btn-sm px-4'
                                      data-bs-toggle='modal'
                                      data-bs-target='#kt_modal_delete'
                                      onClick={() => setDeleteId(item._id as string)}
                                    >
                                      Delete
                                    </a>
                                  </td>
                                  {/*end::Action=*/}
                                </tr>
                              )
                            })}
                        </tbody>
                      )}
                      {/*end::Table body*/}
                    </table>
                  )}
                </div>
                <Pagination
                  name='promo'
                  currentPage={page}
                  prev_page={promoList?.prev_page}
                  next_page={promoList?.next_page}
                  total_number_of_page={promoList?.total_number_of_page}
                />
              </div>
              {/*end::Table*/}
            </div>
            {/*end::Card body*/}
          </div>
          {/*end::Card*/}
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Post*/}
    </div>
  )
}

export default ListPromo
